module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"NuNu","short_name":"NuNu","start_url":"/","background_color":"#3BB47F","theme_color":"#FFFFFF","display":"minimal-ui","icon":"src/assets/favicon.svg"},
    },{
      plugin: require('/opt/build/repo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
